jQuery(document).ready(function($) {

	/* SET ACTIVE CLASS TO CURRENT URL */
	var pathname = window.location.pathname;
	var currentUrl = window.location.href;
	var baseUrl = $( '.navbar--main' ).data('baseurl');
		//desktop menu each
	    $( ".mainmenu li a" ).each(function( index ) {
	        if(currentUrl.indexOf($( this ).attr('href')) > -1 && $( this ).attr('href') != baseUrl) {
	            $( this ).addClass('mainmenu__link--active');
					}
					if(currentUrl.indexOf('clanky') > -1 && ($( this ).attr('href')).indexOf('#clanky') > -1) {
						$( this ).addClass('mainmenu__link--active');
					}
	    });
	//}

});